import styles from "./button.module.scss";
import cn from "classnames";
import { ButtonBaseProps, ButtonSize } from "./button.typer";
import { Link } from "react-router";
import { MouseEventHandler } from "react";
import useDebug from "../../hooks/useDebug";
import { track } from "../../api/tracking";

type IconLinkProps = ButtonBaseProps & {
  text: string;
  navigateTo: string;
  ariaLabel?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  preventScrollReset?: boolean;
};

export default function InternLinkButton({
  buttonType = "primary",
  size = "large",
  text,
  icon,
  setIconLast = false,
  navigateTo,
  style,
  className,
  alignButtonLeft,
  ariaLabel,
  trackingName,
  preventScrollReset = false,
  ...rest
}: IconLinkProps) {
  const order = setIconLast ? styles.flipIconAndText : "";
  const iconSize = ButtonSize[size] === ButtonSize.small ? "small" : "medium";
  const displayedIcon = icon && <sds-icon name={`${icon}-material-outlined`} />;
  const debug = useDebug();

  const trackClickAndHandle = () => {
    track.userAction("Click InternLink", trackingName);
  };

  return (
    <Link
      {...rest}
      to={navigateTo}
      className={cn(
        styles.iconLinkStructure,
        styles.iconLink,
        styles[buttonType],
        styles[size],
        alignButtonLeft ? styles.alignButtonLeft : "",
        className,
        iconSize,
        order,
        style ? style : "",
        debug ? styles.debugTooltip : "",
      )}
      aria-label={ariaLabel}
      onClick={trackClickAndHandle}
      data-tracking-name={trackingName}
      preventScrollReset={preventScrollReset}
    >
      <span className={cn(styles.primaryText)}>
        {displayedIcon}
        <span>{text}</span>
      </span>
    </Link>
  );
}
